import { graphql, useStaticQuery } from "gatsby";
export const useProductSwiperData = () => {
  const storeData = useStaticQuery(graphql`
    query ProductsQuery {
       product: allShopifyProduct(limit: 20, filter: {status: {ne: "draft"}}) {
    nodes {
      title
      vendor
      handle
      image {
        childImageSharp {
          gatsbyImageData(width: 200, layout: CONSTRAINED)
        }
      }
    }
  }
  wp: wpComponent(slug: {eq: "product-swiper"}) {
    store: productSwiper {
      logo: storeLogo {
        gatsbyImage(width: 700)
      }
      url: storeUrl
    }
  }
    }
  `);
  if ( storeData.product.nodes[0].title !== "placeholder" ) return storeData;
  else return null
};

export const handleStoreClick = () => { 
  if (typeof window !== undefined && window.gtag) window.gtag('event', 'store_click')
  else console.log("Gtag event did not fire")
}